import { render, staticRenderFns } from "./clinic.vue?vue&type=template&id=92fb6c26&"
import script from "./clinic.vue?vue&type=script&lang=js&"
export * from "./clinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports